import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Battery0BarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"battery_0_bar"}/>
}
